import { DELETE_NOTIFICATION, SHOW_NOTIFICATON } from './notificationActionsType';

export const displayNotification = notification => dispatch => {
  dispatch({ type: SHOW_NOTIFICATON, payload: notification });
};

export const deleteNotification = id => dispatch => {
  dispatch({
    type: DELETE_NOTIFICATION,
    payload: id,
  });
};
